import { PUSH_BASE_INTERNO } from "@/hooks/clienteDoPush";
import { useSincronizacaoDoPush } from "@/hooks/useSincronizacaoDoPush";
import { appDoPush } from "@/lib/push/donoDoPush";

import { AvisoDoPush } from "./AvisoDoPush";
import { TEXTOS_DO_PUSH_DO_PORTAL, TEXTOS_DO_PUSH_INTERNO } from "./CartaoPushDoAparelho.textos";

/**
 * Mantém o push deste aparelho em dia: ao abrir o app, ao voltar o foco e quando o service worker avisa que a inscrição girou, chama a
 * sincronização do push (`lib/push/sincronizarPush.ts`, pelo hook `useSincronizacaoDoPush`). Não renderiza nada.
 *
 * Antes (passo 8, 05/10/2026) ele reenviava a inscrição do navegador ao servidor em TODA abertura, às cegas, e só para quem ainda tinha
 * inscrição. Agora pergunta antes de reenviar (`POST /push/verificar`, só leitura): se o servidor conhece o endpoint, não reenvia; se
 * largou um que já conhecia, renova; se nunca o teve, adota o endpoint vivo; e se a inscrição SUMIU do navegador com a permissão ainda
 * dada, religa sozinho (uma vez, em silêncio, para o aparelho de antes desta mudança; sempre, para quem tinha ligado). Quem apertou
 * Desligar não é religado. O que a sincronização não resolve sozinha (permissão que voltou a perguntar, bloqueio, religar que falhou) é o
 * `aviso` que o hook devolve, e este componente o mostra na tela (`AvisoDoPush`, com os textos do app: os do portal quando o `basePath` é
 * o do portal). Qualquer outro resultado não renderiza nada.
 *
 * A marca do dono segue valendo (decisão do Augusto, 12/10/2026: "só num clique"). O SE_WEB interno e o Portal do Parceiro dividem a
 * origem e o service worker, logo a inscrição do navegador; o servidor dá a linha a quem reenvia por último (R10). A marca
 * `seweb:push-dono` (`lib/push/donoDoPush.ts`) diz quem é o dono: marca do outro app, nem pergunta nem reenvia; marca deste app, ou SEM
 * marca (aparelho de antes, ou depois de uma saída de sessão), sincroniza e adota — ninguém perde o push que já funciona. Quem troca o
 * dono é um clique de ligar ou um login.
 */
export function ReinscricaoDoPush({
  basePath = PUSH_BASE_INTERNO,
}: { basePath?: string } = {}): JSX.Element | null {
  const resultado = useSincronizacaoDoPush(basePath);
  if (resultado?.tipo !== "aviso") return null;
  const textos =
    appDoPush(basePath) === "portal" ? TEXTOS_DO_PUSH_DO_PORTAL : TEXTOS_DO_PUSH_INTERNO;
  // `key={qual}`: o aviso decide se aparece na montagem; quando a sincronização troca de um aviso para outro (a permissão foi de
  // "perguntar" para "negada"), o novo é um aviso novo, com o seu silêncio e o seu "já mostrado".
  return (
    <AvisoDoPush key={resultado.qual} qual={resultado.qual} basePath={basePath} textos={textos} />
  );
}
